<template>
  <div class="learingIndex">
    <commonHeader></commonHeader>
    <indexMapList></indexMapList>
  </div>
</template>
<script>
import indexMapList from "./../components/index-map-list.vue";
import commonHeader from "./../components/common-header.vue";
import cfg from "./../utils/config";
import L from "leaflet";

export default {
  name: "learingIndex",
  data() {
    return {
      swipeable: "true",
      param: {}
    };
  },
  methods: {
    
    getCourseItem: function(obj) {
      if (obj) {
        this.param.rcom = true;
        this.param.page = 3;
      } else {
        this.param.rcom = "";
        this.param.page = 10;
      }
      // IndexApi.coursesItem(this.param, (ret, err) => {
      //   if (err) {
      //     console.log(err);
      //   } else {
      //     if (obj) {
      //       this.rcomData = ret.data;
      //     } else {
      //       this.courseData = ret.data;
      //     }
      //   }
      // });
    }
  },
  watch: {
    
  },
  mounted: function() {

  },
  components: {
    indexMapList,
    commonHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-tabbar > .mint-tab-item.is-selected {
    background-color: #eaeaea;
    color: #E60202;
}
.learingIndex {
  text-align: center;
}
.learingFooter {
  color: $cl7;
  margin-top: 51px;
  .icon {
    display: block;
    font-size: 22px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/module-index/index.vue